// extracted by mini-css-extract-plugin
var _1 = "Messages-module__animateUploadProgressBarWidth--lJMkT";
var _2 = "Messages-module__animatedBackground--mI2a2";
var _3 = "Messages-module__dots--gwrgK";
var _4 = "Messages-module__errorMessage--uH3EG";
var _5 = "Messages-module__hasMessages--I6Slb";
var _6 = "Messages-module__isEditing--Z2V3G";
var _7 = "Messages-module__isOpen--lz1Gz";
var _8 = "Messages-module__lastMessageExchange--QJP0n";
var _9 = "Messages-module__loadingIndicator--RdHkk";
var _a = "Messages-module__message--BVINk";
var _b = "Messages-module__messagesContainer--IDQ5E";
var _c = "Messages-module__overflowMenuButton--wzqai";
var _d = "Messages-module__overflowMenuContainer--aGjQi";
var _e = "Messages-module__overflowMenuFloating--Payni";
var _f = "40px";
var _10 = "Messages-module__postPills--xrOs0";
var _11 = "Messages-module__system--y_DkT";
var _12 = "Messages-module__user--KypKU";
var _13 = "Messages-module__userMessageContent--szfTR";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "dots", _4 as "errorMessage", _5 as "hasMessages", _6 as "isEditing", _7 as "isOpen", _8 as "lastMessageExchange", _9 as "loadingIndicator", _a as "message", _b as "messagesContainer", _c as "overflowMenuButton", _d as "overflowMenuContainer", _e as "overflowMenuFloating", _f as "paddingBottom", _10 as "postPills", _11 as "system", _12 as "user", _13 as "userMessageContent" }
